import { render, staticRenderFns } from "./CoozzyEmailIcon.vue?vue&type=template&id=1bc8d66d&scoped=true"
import script from "./CoozzyEmailIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyEmailIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyEmailIcon.vue?vue&type=style&index=0&id=1bc8d66d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc8d66d",
  null
  
)

export default component.exports